module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage",
    attrs: {
      "id": "HOMEPAGE-SWF"
    },
    on: {
      "click": function($event) {
        return _vm.homePageClick()
      }
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "180px",
      "top": "0",
      "right": "0",
      "bottom": "20px",
      "background": "#2a2a2a"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu cl-effect-4"
  }, [_c('ul', [_vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      class: {
        'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleMenu(index, _vm.menu)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.nickname) + "\n                    "), _c('div', {
      staticClass: "board"
    })])
  }), _vm._v(" "), (_vm.menuMore) ? _c('i', {
    staticClass: "el-icon-d-arrow-right menu-more",
    staticStyle: {
      "line-height": "40px",
      "transform": "rotate(90deg)",
      "cursor": "pointer",
      "color": "#fff",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleMenuMore($event)
      }
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('el-popover', {
    ref: "qq-popover",
    attrs: {
      "placement": "bottom",
      "width": "248",
      "trigger": "hover",
      "open-delay": 500
    }
  }, [_c('section', {
    staticClass: "class-qq-popover"
  }, [_c('img', {
    attrs: {
      "src": require("./home_qq_contact.png")
    }
  })])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "popover",
      rawName: "v-popover:qq-popover",
      arg: "qq-popover"
    }],
    staticClass: "class-qq-icon"
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "class-vip-icon",
    on: {
      "click": function($event) {
        return _vm.handleOpenVip(true)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./icon-vip-svg.svg")
    }
  })]), _vm._v(" "), _c('el-popover', {
    ref: "userinfo-popover",
    attrs: {
      "placement": "bottom",
      "width": "250",
      "trigger": "click"
    }
  }, [_c('section', {
    staticClass: "userinfo_popover"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.userinfo.avatarInfo == null) ? _c('img', {
    attrs: {
      "src": require("./avatar.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userinfo.avatarInfo) ? _c('img', {
    attrs: {
      "src": _vm.userinfo.avatarInfo
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_c('div', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.userinfo.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "identity"
  }, [_vm._v(_vm._s(_vm.identity.name))])]), _vm._v(" "), _c('div', {
    staticClass: "user_operation"
  }, _vm._l((_vm.userInfo_data), function(item, index) {
    return _c('div', {
      staticClass: "item",
      staticStyle: {
        "display": "inline-block",
        "background": "#fff",
        "margin-right": "30px"
      },
      on: {
        "click": function($event) {
          return _vm.handleOperation(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "user_export"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "height": "20px",
      "background": "#fff",
      "line-height": "20px",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s('点数:' + _vm.user_export_money))]), _vm._v(" "), _c('el-button', {
    staticClass: "user_recharge",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleRecharge(true)
      }
    }
  }, [_vm._v("充值")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLimitTimeValid),
      expression: "isLimitTimeValid"
    }],
    staticClass: "limittime"
  }, [_vm._v("有效期至:" + _vm._s(_vm.timestamp(_vm.identity.limittime)))]), _vm._v(" "), _c('div', {
    staticClass: "login-out"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.handleLoginOut
    }
  }, [_vm._v("退出登录")])], 1)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "popover",
      rawName: "v-popover:userinfo-popover",
      arg: "userinfo-popover"
    }],
    staticClass: "userinfo"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.userinfo.avatarInfo == null) ? _c('img', {
    attrs: {
      "src": require("./avatar.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userinfo.avatarInfo) ? _c('img', {
    attrs: {
      "src": _vm.userinfo.avatarInfo
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.userinfo.nickname))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuMoreList),
      expression: "menuMoreList"
    }],
    staticClass: "menu-more-list"
  }, _vm._l((_vm.listMenuLast), function(item, index) {
    return _c('div', {
      staticClass: "menu-more-list-item",
      on: {
        "click": function($event) {
          return _vm.handleListMenuLast(index, _vm.listMenuLast)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.nickname) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "slidebar"
  }, [_c('div', {
    staticClass: "menu cl-effect-5"
  }, [_c('div', {
    class: {
      'active': _vm.aiimage_status
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aiimage_status),
      expression: "aiimage_status"
    }],
    staticClass: "left-border"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-icon ai"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-title",
    attrs: {
      "data-hover": "AI生成"
    },
    on: {
      "click": function($event) {
        return _vm.handleAiImage()
      }
    }
  }, [_vm._v("AI生成")])]), _vm._v(" "), _vm._l((_vm.menu_category), function(item, index) {
    return _c('div', {
      class: {
        'status': item.status, 'active': item.active
      },
      on: {
        "click": function($event) {
          return _vm.handleMenuCategory(item, index, _vm.menu_category)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.active),
        expression: "item.active"
      }],
      staticClass: "left-border"
    }), _vm._v(" "), _c('span', {
      staticClass: "left-icon",
      class: item.type
    }), _vm._v(" "), _c('span', {
      staticClass: "left-title",
      attrs: {
        "data-hover": item.name
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _c('div', {
    class: {
      'active': _vm.package_status
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.package_status),
      expression: "package_status"
    }],
    staticClass: "left-border"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-icon",
    class: _vm.left_menu_buy
  }), _vm._v(" "), _c('span', {
    staticClass: "left-title",
    attrs: {
      "data-hover": "购买的素材"
    },
    on: {
      "click": function($event) {
        return _vm.handlePackage()
      }
    }
  }, [_vm._v("购买的素材")])])], 2)]), _vm._v(" "), (!_vm.upload && !_vm.no_permission && !_vm.package_status && !_vm.aiimage_status) ? _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'anim'),
      expression: "type == 'anim'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("动画")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'scene'),
      expression: "type == 'scene'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("场景")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'material'),
      expression: "type == 'material'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("形象")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'prop'),
      expression: "type == 'prop'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("道具")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'action'),
      expression: "type == 'action'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("动作")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'bgm'),
      expression: "type == 'bgm'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("背景音乐")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'team'),
      expression: "type == 'team'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("成员")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.team_management_result.length) + "/" + _vm._s(_vm.team_manager_numbers) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'template'),
      expression: "type == 'template'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("模版")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'component'),
      expression: "type == 'component'"
    }],
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("组件")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("(" + _vm._s(_vm.total) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialog_button_group_1_visible && !_vm.team_management),
      expression: "dialog_button_group_1_visible && !team_management"
    }],
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_key),
      expression: "search_key"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.text
    },
    domProps: {
      "value": (_vm.search_key)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_key.length > 0),
      expression: "search_key.length > 0"
    }],
    staticClass: "el-icon-close button",
    on: {
      "click": _vm.handleSearchClose
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-search button",
    on: {
      "click": _vm.handleSearch
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialog_button_group_1_visible && !_vm.team_management),
      expression: "dialog_button_group_1_visible && !team_management"
    }],
    staticClass: "button-group"
  }, [(_vm.hasManagementPermission(_vm.type)) ? _c('el-button', {
    staticStyle: {
      "background": "#7ab3f6",
      "border-color": "#7ab3f6",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.dialog_folder_create_visible = true
      }
    }
  }, [_vm._v("创建文件夹")]) : _vm._e(), _vm._v(" "), (_vm.hasManagementPermission(_vm.type)) ? _c('el-button', {
    staticStyle: {
      "background": "#7ab3f6",
      "border-color": "#7ab3f6",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleButtonGroup1
    }
  }, [_vm._v(" 管理")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('anim') && _vm.type == 'anim') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.handleCreateAnim()
      }
    }
  }, [_vm._v(" 创建动画")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('scene') && _vm.type == 'scene') ? _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v(" 创建场景 ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": {
        type: 'scene',
        action: 'upload'
      }
    }
  }, [_vm._v("上传场景")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        type: 'scene',
        action: 'ai'
      }
    }
  }, [_vm._v("AI生成")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('material') && _vm.type == 'material') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.handleUploading('material')
      }
    }
  }, [_vm._v(" 创建形象")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('prop') && _vm.type == 'prop') ? _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v(" 创建道具 ")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": {
        type: 'prop',
        action: 'upload'
      }
    }
  }, [_vm._v("上传道具")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": {
        type: 'prop',
        action: 'ai'
      }
    }
  }, [_vm._v("AI生成")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('action') && _vm.type == 'action') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.handlePostCreateAction
    }
  }, [_vm._v(" 创建动作")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('bgm') && _vm.type == 'bgm') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.handleUploading('bgm')
      }
    }
  }, [_vm._v(" 创建背景音乐")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('component') && _vm.type == 'component') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.handleUploading('component')
      }
    }
  }, [_vm._v(" 创建组件")]) : _vm._e(), _vm._v(" "), (_vm.hasCreatePermission('soundeffect') && _vm.type == 'soundeffect') ? _c('el-button', {
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "font-size": "14px",
      "font-family": "PingFangSC-Regular"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.handleUploading('soundeffect')
      }
    }
  }, [_vm._v(" 创建音效")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialog_button_group_2_visible),
      expression: "dialog_button_group_2_visible"
    }],
    staticClass: "button-group"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.folder_file_data.length == 0),
      expression: "folder_file_data.length == 0"
    }],
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("请从下方选择要批量操作的内容！")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.folder_file_data.length > 0),
      expression: "folder_file_data.length > 0"
    }],
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("已选中 "), _c('strong', [_vm._v(_vm._s(_vm.folder_file_data.length))]), _vm._v(" 项")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.disabledVisible
    },
    on: {
      "click": function($event) {
        return _vm.handleDialogEdit('batch')
      }
    }
  }, [_c('i', {
    staticClass: "icon-folder-open"
  }), _vm._v(" 移动到...")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type != 'anim' && _vm.type != 'folder'),
      expression: "type != 'anim' && type != 'folder'"
    }],
    attrs: {
      "type": "success",
      "disabled": _vm.disabledVisible
    },
    on: {
      "click": function($event) {
        return _vm.handleDialogEdit('batch')
      }
    }
  }, [_c('i', {
    staticClass: "icon-magic-wand"
  }), _vm._v(" 发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.disabledVisible
    },
    on: {
      "click": function($event) {
        return _vm.handleDialogDelete('other', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-bin"
  }), _vm._v(" 删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleButtonGroup2
    }
  }, [_c('i', {
    staticClass: "icon-x-altx-alt"
  }), _vm._v(" 取消")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_management),
      expression: "team_management"
    }],
    staticClass: "button-team-managent"
  }, [_c('el-button', {
    style: (_vm.team_management_result.length >= _vm.team_manager_numbers ?
      'background:#ccc;border-color:#ccc;height:30px;cursor:not-allowed;' :
      'background:#ffa225;border-color:#ffa225;height:30px;'),
    attrs: {
      "type": "primary",
      "size": "mini",
      "disabled": _vm.team_management_result.length >= _vm.team_manager_numbers
    },
    on: {
      "click": _vm.addTeamMembers
    }
  }, [_vm._v(" \n                    添加团队成员\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showAiImageComponent) ? _c('div', {
    staticClass: "ai-image"
  }, [(_vm.showAiImageComponent) ? _c('AiImage', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "token": _vm.token
    },
    on: {
      "navigate-to-sdui": _vm.handleNavigateToSdui
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showAiImageComponent && !_vm.upload && !_vm.no_permission && !_vm.package_status && !_vm.team_management && !_vm.aiimage_status) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "element-loading-text": "数据加载中"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumb), function(item, index) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.breadcrumb.length > 1),
        expression: "breadcrumb.length > 1"
      }],
      on: {
        "click": function($event) {
          return _vm.handleTargetNav(index, item.folder_id)
        }
      }
    }, [_vm._v(_vm._s('/ ' + item.name))])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.no_result),
      expression: "!no_result"
    }],
    staticClass: "list cl-effect-8"
  }, [_vm._l((_vm.data), function(item, index) {
    return (_vm.type != 'action') ? _c('div', {
      staticClass: "item",
      class: _vm.homeListItemWH,
      on: {
        "mouseover": _vm.handleFolderGroupShow,
        "mouseout": _vm.handleFolderGroupHide
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.folder_file_data),
        callback: function($$v) {
          _vm.folder_file_data = $$v
        },
        expression: "folder_file_data"
      }
    }, [_c('el-checkbox', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dialog_folder_group_selected_visible),
        expression: "dialog_folder_group_selected_visible"
      }],
      staticClass: "checkbox",
      attrs: {
        "label": item.id,
        "size": "large"
      },
      on: {
        "click": function($event) {
          return _vm.change($event)
        }
      }
    })], 1), _vm._v(" "), (item.type == 'folder') ? _c('div', {
      staticClass: "pic folder",
      class: _vm.homeListItemWH,
      on: {
        "click": function($event) {
          return _vm.handleTarget(item.type, item.title, item.id, item.proportion, item)
        }
      }
    }, [(_vm.type != 'material' && _vm.type != 'prop') ? _c('img', {
      staticClass: "folder-img",
      attrs: {
        "src": require("./folder.png")
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type == 'material' || _vm.type == 'prop') ? _c('img', {
      staticClass: "folder-material",
      attrs: {
        "src": require("./folder.png")
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dialog_button_group_1_visible),
        expression: "dialog_button_group_1_visible"
      }],
      staticClass: "folder-group"
    }, [(_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "修改文件夹信息",
        "placement": "top-start"
      }
    }, [_c('i', {
      staticClass: "icon-home_edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogEdit('default', item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "删除文件夹",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogDelete(item.type, item.title, item.id)
        }
      }
    })]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (item.type != 'folder') ? _c('div', {
      staticClass: "pic",
      class: _vm.homeListItemWH,
      on: {
        "click": function($event) {
          return _vm.handleTarget(item.type, item.title, item.id, item.proportion, item)
        }
      }
    }, [(item.type == 'anim' || item.type == 'template') ? _c('div', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(item.extdata ? _vm.timestamp1(item.extdata.duration) : '00:00'))]) : _vm._e(), _vm._v(" "), (item.type == 'anim' || item.type == 'scene' || item.type == 'template' || item.type == 'component') ? _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.preview),
        expression: "item.preview"
      }],
      staticClass: "item-img",
      attrs: {
        "src": item.preview
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "material-img-con"
    }, [(item.type == 'material' || item.type == 'prop') ? _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.preview),
        expression: "item.preview"
      }],
      staticClass: "material-img",
      attrs: {
        "src": item.preview
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'bgm') ? _c('img', {
      staticClass: "material-img",
      attrs: {
        "src": require("./music.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'anim' || item.type == 'scene') ? _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.preview),
        expression: "!item.preview"
      }],
      staticClass: "material-img-vertical-default",
      attrs: {
        "src": require("./conver_scene_horizontal.png")
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 'material' || item.type == 'prop') ? _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.preview),
        expression: "!item.preview"
      }],
      staticClass: "material-img-horizontal-default",
      attrs: {
        "src": require("./conver_material_vertical.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dialog_button_group_1_visible),
        expression: "dialog_button_group_1_visible"
      }],
      staticClass: "folder-group"
    }, [(_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "修改标题和简介",
        "placement": "top-start"
      }
    }, [_c('i', {
      staticClass: "icon-home_edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogEdit('default', item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == 'anim' || _vm.type == 'scene' || _vm.type == 'action' || _vm.type == 'template' || _vm.type == 'component'),
        expression: "type == 'anim' || type == 'scene' || type == 'action' || type == 'template' || type == 'component'"
      }],
      attrs: {
        "effect": "dark",
        "content": "创建副本",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "icon-home_aadd",
      staticStyle: {
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleFolderGroupCopy(item.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == 'anim'),
        expression: "type == 'anim'"
      }],
      attrs: {
        "effect": "dark",
        "content": "另存为模版",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "icon-home_template_save",
      staticStyle: {
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleTemplateSave(item.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.type == 'material'),
        expression: "type == 'material'"
      }],
      attrs: {
        "effect": "dark",
        "content": "重新上传",
        "placement": "top-end"
      }
    }, [_c('i', {
      staticClass: "icon-home_uploading",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleAfreshUploading(item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "删除",
        "placement": "top-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogDelete(item.type, item.title, item.id)
        }
      }
    })]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s((item.type == 'material' || item.type == 'prop') ? (item.title.length > 10 ? item.title.substring(0, 10) + '...' : item.title) : item.title))]), _vm._v(" "), (item.type != 'folder') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("作者:   " + _vm._s(item.creator))]) : _vm._e(), _vm._v(" "), (item.type == 'folder') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date",
      class: _vm.homeDateLeft
    }, [_vm._v(_vm._s(item.type != 'folder' ? _vm.timestamp(item.updateTime) : _vm.timestamp(item.createTime)))])], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.type == 'action') ? _c('div', {
      staticClass: "list-action",
      staticStyle: {
        "width": "260px",
        "height": "80px",
        "margin-right": "20px",
        "margin-bottom": "20px",
        "cursor": "pointer",
        "position": "relative",
        "display": "block",
        "float": "left",
        "background": "#303030"
      },
      on: {
        "mouseover": _vm.handleFolderGroupShow,
        "mouseout": _vm.handleFolderGroupHide,
        "click": function($event) {
          return _vm.handleTarget(item.type, item.title, item.id, item.proportion, item)
        }
      }
    }, [_c('div', {
      staticClass: "top",
      staticStyle: {
        "position": "relative",
        "top": "0",
        "left": "0",
        "right": "0",
        "height": "40px",
        "background": "#626262"
      }
    }, [(item.type == 'folder') ? _c('div', [_c('img', {
      staticStyle: {
        "position": "relative",
        "top": "5px",
        "left": "8px",
        "height": "30px",
        "width": "40px"
      },
      attrs: {
        "src": require("./action-folder.png")
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "position": "absolute",
        "top": "13px",
        "bottom": "10px",
        "right": "5px",
        "left": "60px",
        "color": "#e2e2e2"
      }
    }, [_vm._v(_vm._s(item.title.length > 13 ? item.title.substring(0, 13) + '...' : item.title))])]) : _vm._e(), _vm._v(" "), (item.type != 'folder') ? _c('div', [_c('div', {
      staticStyle: {
        "position": "absolute",
        "top": "13px",
        "bottom": "10px",
        "right": "5px",
        "left": "8px",
        "color": "#e2e2e2"
      }
    }, [_vm._v(_vm._s(item.title.length > 13 ? item.title.substring(0, 13) + '...' : item.title))]), _vm._v(" "), (item.extdata && item.extdata.movable !== null) ? _c('div', {
      staticClass: "group",
      staticStyle: {
        "position": "absolute",
        "top": "13px",
        "right": "5px",
        "color": "#2f2f2f",
        "-webkit-transform": "scale(0.8)"
      }
    }, [(item.extdata.movable && item.extdata.looped) ? _c('i', {
      staticClass: "icon-action_move"
    }) : _vm._e(), _vm._v(" "), (item.extdata.looped && !item.extdata.movable) ? _c('i', {
      staticClass: "icon-action_circulation"
    }) : _vm._e(), _vm._v(" "), (!item.extdata.movable || !item.extdata.looped) ? _c('i', {
      staticClass: "icon-action_time"
    }) : _vm._e(), _vm._v(" "), (!item.extdata.movable || !item.extdata.looped) ? _c('span', {
      staticStyle: {
        "color": "#e2e2e2"
      }
    }, [_vm._v(_vm._s(item.extdata.duration ? item.extdata.duration.toFixed(2) + '秒' : ''))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bottom",
      staticStyle: {
        "position": "relative",
        "bottom": "0",
        "left": "0",
        "right": "0",
        "height": "40px"
      }
    }, [(item.type != 'folder') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("作者:   " + _vm._s(item.creator))]) : _vm._e(), _vm._v(" "), (item.type == 'folder') ? _c('div', {
      staticClass: "name"
    }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.type != 'folder' ? _vm.timestamp(item.updateTime) : _vm.timestamp(item.createTime)))]), _vm._v(" "), (item.type == 'folder') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dialog_button_group_1_visible),
        expression: "dialog_button_group_1_visible"
      }],
      staticClass: "folder-group"
    }, [(_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "修改文件夹信息",
        "placement": "top-start"
      }
    }, [_c('i', {
      staticClass: "icon-home_edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogEdit('default', item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "删除文件夹",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogDelete(item.type, item.title, item.id)
        }
      }
    })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type != 'folder') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dialog_button_group_1_visible),
        expression: "dialog_button_group_1_visible"
      }],
      staticClass: "folder-group"
    }, [(_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "修改标题和简介",
        "placement": "top-start"
      }
    }, [_c('i', {
      staticClass: "icon-home_edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogEdit('default', item)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "创建副本",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "icon-home_aadd",
      staticStyle: {
        "color": "#fff",
        "font-size": "28px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleFolderGroupCopy(item.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.permission == 2 || (_vm.permission == 1 && _vm.self_oid == item.creator_user_id)) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": "删除",
        "placement": "top-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDialogDelete(item.type, item.title, item.id)
        }
      }
    })]) : _vm._e()], 1) : _vm._e()])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.no_result),
      expression: "no_result"
    }],
    staticClass: "no_results"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.category_txt) + "暂时还没有内容呦~^-^~")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.length > 0),
      expression: "data.length > 0"
    }],
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.current_page,
      "page-sizes": [20, 50],
      "page-size": _vm.page_size,
      "pager-count": 5,
      "total": _vm.total,
      "layout": "total, sizes, prev, pager, next, jumper",
      "size": "small"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.team_management) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_management && _vm.tab_team_status == '0' && _vm.identity.permission.team == '2'),
      expression: "team_management && tab_team_status == '0' && identity.permission.team == '2'"
    }],
    staticClass: "team_management"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "element-loading-text": "数据加载中"
    }
  }), _vm._v(" "), _c('el-table', {
    staticClass: "team_management_table",
    staticStyle: {
      "width": "96%",
      "left": "20px"
    },
    attrs: {
      "data": _vm.team_management_result,
      "border": "",
      "max-height": "750",
      "row-style": _vm.team_managent_row_style,
      "header-cell-style": _vm.team_managent_row_style
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员昵称",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.nickname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成员账号",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.username))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色",
      "fit": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.permissions), function(item, index) {
          return _c('span', {
            staticClass: "name-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_c('el-tag', {
            staticStyle: {
              "margin-bottom": "10px",
              "border-color": "#E8E8E8",
              "color": "#e2e2e2",
              "background": "#303030"
            },
            attrs: {
              "size": "medium",
              "color": "white"
            }
          }, [_vm._v(_vm._s(_vm.classMap[item.type] + '(' + _vm.team_select[item.permission] + ')'))]), _vm._v(" "), _c('span', [_vm._v(" ")])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "225"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "margin-left": "40px",
            "background": "#7AB3F6",
            "color": "white"
          },
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleTeamMemberEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.memberDelete(scope.$index)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-dialog', {
          attrs: {
            "title": "删除",
            "visible": _vm.centerDialogVisible,
            "width": "30%",
            "center": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        }, [_c('span', [_vm._v("确定要删除此成员吗?")]), _vm._v(" "), _c('span', {
          staticClass: "dialog-footer",
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.centerDialogVisible = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleTeamMemberDelete()
            }
          }
        }, [_vm._v("确 定")])], 1)])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_add_edit && _vm.tab_team_status == '0' && _vm.type == 'team'),
      expression: "team_add_edit && tab_team_status == '0' && type == 'team'"
    }],
    staticClass: "team_add_edit",
    staticStyle: {
      "background": "#303030"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('el-button', {
    staticClass: "back_btn",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": _vm.hanadleBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.team_add_edit_title) + "团队成员")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "top": "800px",
      "right": "0",
      "bottom": "0px",
      "background": "#303030",
      "z-index": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "96%",
      "top": "60px",
      "right": "0",
      "bottom": "0px",
      "background": "#303030",
      "z-index": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_management_content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "成员账号:",
      "prop": "name"
    }
  }, [(_vm.team_add_edit_title == '添加') ? _c('el-input', {
    attrs: {
      "placeholder": "请输入成员专业版账号"
    },
    on: {
      "blur": _vm.teamTitleInput
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", $$v)
      },
      expression: "ruleForm.name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑') ? _c('div', {
    staticStyle: {
      "color": "#e2e2e2"
    }
  }, [_vm._v(_vm._s(_vm.team_member_info.username))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成员昵称:",
      "prop": "name"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_member_exist),
      expression: "team_member_exist"
    }],
    staticStyle: {
      "color": "#e2e2e2"
    }
  }, [_vm._v(_vm._s(_vm.team_member_name))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.team_member_exist),
      expression: "!team_member_exist"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("此账号未注册!")]), _vm._v(" "), (_vm.team_add_edit_title == '编辑') ? _c('div', {
    staticStyle: {
      "color": "#e2e2e2"
    }
  }, [_vm._v(_vm._s(_vm.team_member_info.nickname))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成员角色:",
      "prop": "name"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.team_management_check_group),
      callback: function($$v) {
        _vm.team_management_check_group = $$v
      },
      expression: "team_management_check_group"
    }
  }, [_c('div', [_c('el-checkbox', {
    attrs: {
      "label": "动画",
      "name": "type"
    },
    on: {
      "change": _vm.handleAnimCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[0].checked),
      expression: "team_class_member[0].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleAnimSelect
    },
    model: {
      value: (_vm.team_select_0),
      callback: function($$v) {
        _vm.team_select_0 = $$v
      },
      expression: "team_select_0"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[0].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[0].checked),
      expression: "team_class_member[0].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleAnimSelect
    },
    model: {
      value: (_vm.team_select_0),
      callback: function($$v) {
        _vm.team_select_0 = $$v
      },
      expression: "team_select_0"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[0].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[0].checked && _vm.team_class_member[0].permission != '0' && _vm.team_class_member[0].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[0].checked),
      expression: "team_class_member[0].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleAnimSelect
    },
    model: {
      value: (_vm.team_select_0),
      callback: function($$v) {
        _vm.team_select_0 = $$v
      },
      expression: "team_select_0"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[0].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[0].checked),
      expression: "team_class_member[0].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleAnimSelect
    },
    model: {
      value: (_vm.team_select_0),
      callback: function($$v) {
        _vm.team_select_0 = $$v
      },
      expression: "team_select_0"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "形象",
      "name": "type"
    },
    on: {
      "change": _vm.handleMaterialCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[1].checked),
      expression: "team_class_member[1].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleMaterialSelect
    },
    model: {
      value: (_vm.team_select_1),
      callback: function($$v) {
        _vm.team_select_1 = $$v
      },
      expression: "team_select_1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[1].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[1].checked),
      expression: "team_class_member[1].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleMaterialSelect
    },
    model: {
      value: (_vm.team_select_1),
      callback: function($$v) {
        _vm.team_select_1 = $$v
      },
      expression: "team_select_1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[1].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[1].checked && _vm.team_class_member[1].permission != '0' && _vm.team_class_member[1].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[1].checked),
      expression: "team_class_member[1].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleMaterialSelect
    },
    model: {
      value: (_vm.team_select_1),
      callback: function($$v) {
        _vm.team_select_1 = $$v
      },
      expression: "team_select_1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[1].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[1].checked),
      expression: "team_class_member[1].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleMaterialSelect
    },
    model: {
      value: (_vm.team_select_1),
      callback: function($$v) {
        _vm.team_select_1 = $$v
      },
      expression: "team_select_1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "动作",
      "name": "type"
    },
    on: {
      "change": _vm.handleActionCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[2].checked),
      expression: "team_class_member[2].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleActionSelect
    },
    model: {
      value: (_vm.team_select_2),
      callback: function($$v) {
        _vm.team_select_2 = $$v
      },
      expression: "team_select_2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[2].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[2].checked),
      expression: "team_class_member[2].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleActionSelect
    },
    model: {
      value: (_vm.team_select_2),
      callback: function($$v) {
        _vm.team_select_2 = $$v
      },
      expression: "team_select_2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[2].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[2].checked && _vm.team_class_member[2].permission != '0' && _vm.team_class_member[2].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[2].checked),
      expression: "team_class_member[2].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleActionSelect
    },
    model: {
      value: (_vm.team_select_2),
      callback: function($$v) {
        _vm.team_select_2 = $$v
      },
      expression: "team_select_2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[2].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[2].checked),
      expression: "team_class_member[2].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleActionSelect
    },
    model: {
      value: (_vm.team_select_2),
      callback: function($$v) {
        _vm.team_select_2 = $$v
      },
      expression: "team_select_2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "道具",
      "name": "type"
    },
    on: {
      "change": _vm.handlePropCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[3].checked),
      expression: "team_class_member[3].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadlePropSelect
    },
    model: {
      value: (_vm.team_select_3),
      callback: function($$v) {
        _vm.team_select_3 = $$v
      },
      expression: "team_select_3"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[3].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[3].checked),
      expression: "team_class_member[3].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadlePropSelect
    },
    model: {
      value: (_vm.team_select_3),
      callback: function($$v) {
        _vm.team_select_3 = $$v
      },
      expression: "team_select_3"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[3].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[3].checked && _vm.team_class_member[3].permission != '0' && _vm.team_class_member[3].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[3].checked),
      expression: "team_class_member[3].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadlePropSelect
    },
    model: {
      value: (_vm.team_select_3),
      callback: function($$v) {
        _vm.team_select_3 = $$v
      },
      expression: "team_select_3"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[3].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[3].checked),
      expression: "team_class_member[3].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadlePropSelect
    },
    model: {
      value: (_vm.team_select_3),
      callback: function($$v) {
        _vm.team_select_3 = $$v
      },
      expression: "team_select_3"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "场景",
      "name": "type"
    },
    on: {
      "change": _vm.handleSceneCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[4].checked),
      expression: "team_class_member[4].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleSceneSelect
    },
    model: {
      value: (_vm.team_select_4),
      callback: function($$v) {
        _vm.team_select_4 = $$v
      },
      expression: "team_select_4"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[4].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[4].checked),
      expression: "team_class_member[4].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleSceneSelect
    },
    model: {
      value: (_vm.team_select_4),
      callback: function($$v) {
        _vm.team_select_4 = $$v
      },
      expression: "team_select_4"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[4].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[4].checked && _vm.team_class_member[4].permission != '0' && _vm.team_class_member[4].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[4].checked),
      expression: "team_class_member[4].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleSceneSelect
    },
    model: {
      value: (_vm.team_select_4),
      callback: function($$v) {
        _vm.team_select_4 = $$v
      },
      expression: "team_select_4"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[4].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[4].checked),
      expression: "team_class_member[4].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleSceneSelect
    },
    model: {
      value: (_vm.team_select_4),
      callback: function($$v) {
        _vm.team_select_4 = $$v
      },
      expression: "team_select_4"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "背景音",
      "name": "type"
    },
    on: {
      "change": _vm.handleBgmCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[5].checked),
      expression: "team_class_member[5].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleBgmSelect
    },
    model: {
      value: (_vm.team_select_5),
      callback: function($$v) {
        _vm.team_select_5 = $$v
      },
      expression: "team_select_5"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[5].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[5].checked),
      expression: "team_class_member[5].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleBgmSelect
    },
    model: {
      value: (_vm.team_select_5),
      callback: function($$v) {
        _vm.team_select_5 = $$v
      },
      expression: "team_select_5"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[5].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[5].checked && _vm.team_class_member[5].permission != '0' && _vm.team_class_member[5].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[5].checked),
      expression: "team_class_member[5].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleBgmSelect
    },
    model: {
      value: (_vm.team_select_5),
      callback: function($$v) {
        _vm.team_select_5 = $$v
      },
      expression: "team_select_5"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[5].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[5].checked),
      expression: "team_class_member[5].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleBgmSelect
    },
    model: {
      value: (_vm.team_select_5),
      callback: function($$v) {
        _vm.team_select_5 = $$v
      },
      expression: "team_select_5"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "模版",
      "name": "type"
    },
    on: {
      "change": _vm.handleTemplateCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[6].checked),
      expression: "team_class_member[6].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleTemplateSelect
    },
    model: {
      value: (_vm.team_select_6),
      callback: function($$v) {
        _vm.team_select_6 = $$v
      },
      expression: "team_select_6"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[6].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[6].checked),
      expression: "team_class_member[6].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleTemplateSelect
    },
    model: {
      value: (_vm.team_select_6),
      callback: function($$v) {
        _vm.team_select_6 = $$v
      },
      expression: "team_select_6"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[6].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[6].checked && _vm.team_class_member[6].permission != '0' && _vm.team_class_member[6].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[6].checked),
      expression: "team_class_member[6].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleTemplateSelect
    },
    model: {
      value: (_vm.team_select_6),
      callback: function($$v) {
        _vm.team_select_6 = $$v
      },
      expression: "team_select_6"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[6].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[6].checked),
      expression: "team_class_member[6].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleTemplateSelect
    },
    model: {
      value: (_vm.team_select_6),
      callback: function($$v) {
        _vm.team_select_6 = $$v
      },
      expression: "team_select_6"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "组件",
      "name": "type"
    },
    on: {
      "change": _vm.handleComponentCheckbox
    }
  }), _vm._v(" "), (_vm.team_add_edit_title == '添加') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[7].checked),
      expression: "team_class_member[7].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleComponentSelect
    },
    model: {
      value: (_vm.team_select_7),
      callback: function($$v) {
        _vm.team_select_7 = $$v
      },
      expression: "team_select_7"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[7].permission == '0') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[7].checked),
      expression: "team_class_member[7].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "查看人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleComponentSelect
    },
    model: {
      value: (_vm.team_select_7),
      callback: function($$v) {
        _vm.team_select_7 = $$v
      },
      expression: "team_select_7"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[7].permission == '1' || (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[7].checked && _vm.team_class_member[7].permission != '0' && _vm.team_class_member[7].permission != '2')) ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[7].checked),
      expression: "team_class_member[7].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "制作人员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleComponentSelect
    },
    model: {
      value: (_vm.team_select_7),
      callback: function($$v) {
        _vm.team_select_7 = $$v
      },
      expression: "team_select_7"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.team_add_edit_title == '编辑' && _vm.team_class_member[7].permission == '2') ? _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_class_member[7].checked),
      expression: "team_class_member[7].checked"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "管理员",
      "size": "mini"
    },
    on: {
      "change": _vm.hanadleComponentSelect
    },
    model: {
      value: (_vm.team_select_7),
      callback: function($$v) {
        _vm.team_select_7 = $$v
      },
      expression: "team_select_7"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "查看人员",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "制作人员",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "管理员",
      "value": "2"
    }
  })], 1) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "team_management_save"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.team_saveBtn_status),
      expression: "!team_saveBtn_status"
    }],
    staticClass: "team_save_btn",
    staticStyle: {
      "background": "lightGray",
      "border-color": "lightGray",
      "width": "220px"
    },
    attrs: {
      "act": "",
      "type": "warning",
      "disabled": _vm.disabled = true
    }
  }, [_vm._v(" 保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.team_saveBtn_status),
      expression: "team_saveBtn_status"
    }],
    staticClass: "team_save_btn",
    staticStyle: {
      "background": "#ffa225",
      "border-color": "#ffa225",
      "width": "220px"
    },
    attrs: {
      "act": "",
      "type": "warning"
    },
    on: {
      "click": _vm.team_management_save
    }
  }, [_vm._v(" 保存")])], 1)]), _vm._v(" "), (_vm.package_status && !_vm.package_detail_status) ? _c('div', {
    staticClass: "package_list_toorbar"
  }, [_c('div', {
    staticClass: "package_list_toorbar_left"
  }, [_vm._v("我购买的素材(" + _vm._s(_vm.package_list_data.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "package_list_toorbar_right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_key_package),
      expression: "search_key_package"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.text
    },
    domProps: {
      "value": (_vm.search_key_package)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchPackage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_key_package = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search_key_package.length > 0),
      expression: "search_key_package.length > 0"
    }],
    staticClass: "el-icon-close button",
    on: {
      "click": _vm.handleSearchClosePackage
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-search button",
    on: {
      "click": _vm.handleSearchPackage
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.package_detail_status) ? _c('div', {
    staticClass: "package_back",
    staticStyle: {
      "background": "#303030",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        return _vm.handleGoBack()
      }
    }
  }, [_vm._v("< 返回")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.package_status),
      expression: "package_status"
    }],
    staticClass: "package"
  }, [(!_vm.package_detail_status && !_vm.no_result) ? _c('div', {
    staticClass: "package_list",
    staticStyle: {
      "position": "static"
    }
  }, [_c('div', {
    staticClass: "package_list_data"
  }, _vm._l((_vm.package_list_data), function(item, index) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.handlePackageDetail(item)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.no_result) ? _c('div', {
    staticClass: "no_results",
    staticStyle: {
      "padding-top": "55px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.category_txt) + "暂时还没有购买东西呦~^-^~")])]) : _vm._e(), _vm._v(" "), (!_vm.package_detail_status) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.package_list_data.length > 0),
      expression: "package_list_data.length > 0"
    }],
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.current_page_pack,
      "page-sizes": [20, 50],
      "page-size": _vm.page_size_pack,
      "total": _vm.total_pack,
      "pager-count": 5,
      "layout": "total, sizes, prev, pager, next, jumper",
      "size": "small"
    },
    on: {
      "size-change": _vm.handleSizeChangePack,
      "current-change": _vm.handleCurrentChangePack
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.package_detail_status && _vm.current_package_id) ? _c('PackageDetail', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "package-id": _vm.current_package_id,
      "token": _vm.token
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.upload) ? _c('upload', {
    attrs: {
      "token": _vm.token,
      "type": _vm.type,
      "teamid": _vm.tab_team_id,
      "handle": _vm.handleC,
      "folderid": _vm.folder_id,
      "uploading": _vm.home_uploading
    }
  }) : _vm._e(), _vm._v(" "), _c('EditUserInfo', {
    attrs: {
      "userInfoShow": _vm.userInfoShow,
      "title": _vm.userInfoTitle,
      "user_icon": _vm.userinfo.avatarInfo
    },
    on: {
      "showUserInfo": _vm.handleUserInfo,
      "changeHomePageUserIcon": _vm.changeHomePageUserIcon
    }
  }), _vm._v(" "), _c('Recharge', {
    attrs: {
      "visible": _vm.pay_money_status
    },
    on: {
      "update:visible": function($event) {
        _vm.pay_money_status = $event
      },
      "showRecharge": _vm.handleRecharge,
      "userCoupon": _vm.handUserCoupon
    }
  }), _vm._v(" "), _c('VipMember', {
    attrs: {
      "visible": _vm.vip_dialog_visible,
      "identity": _vm.identity,
      "teamId": _vm.tab_team_id
    },
    on: {
      "update:visible": function($event) {
        _vm.vip_dialog_visible = $event
      },
      "show-qrcode": _vm.handleQrcode
    }
  }), _vm._v(" "), (_vm.no_permission) ? _c('div', {
    staticClass: "no_permission",
    on: {
      "click": function($event) {
        return _vm.handleOpenVip(true)
      }
    }
  }, [(_vm.type === 'material' || _vm.type === 'action') ? [_vm._v("\n            对不起您没有该权益，请购买专业版\n        ")] : (_vm.type === 'team') ? [_vm._v("\n            对不起您没有该权益，请购买企业版\n        ")] : [_vm._v("\n            对不起您没有该权益，请购买标准版\n        ")]], 2) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "创建文件夹",
      "visible": _vm.dialog_folder_create_visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_folder_create_visible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "body",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件夹名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "autofocus": "",
      "disabled": _vm.folder_creat_input_disabled
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleBtnCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCreateFolder
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.form_all_edit_visible ? '修改标题和简介' : '移动到',
      "visible": _vm.dialog_edit_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_edit_visible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_all_edit_visible),
      expression: "form_all_edit_visible"
    }],
    staticClass: "body",
    attrs: {
      "model": _vm.form_all_edit
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在文件夹",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.clickFieldChangeStatus),
      expression: "!clickFieldChangeStatus"
    }],
    staticClass: "el-tree",
    on: {
      "click": _vm.clickFieldChange
    }
  }, [_c('div', {
    staticClass: "el-tree-node__content",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "el-tree-node__expand-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "el-tree-node__label"
  }, [_vm._v(_vm._s(0 < _vm.breadcrumb.length ? _vm.breadcrumb[_vm.breadcrumb.length - 1].name : ''))])])]), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clickFieldChangeStatus),
      expression: "clickFieldChangeStatus"
    }],
    attrs: {
      "data": _vm.form_all_edit.directory,
      "props": _vm.form_all_edit.defaultProps,
      "highlight-current": true,
      "node-key": "id",
      "default-checked-keys": [_vm.folder_id],
      "current-node-key": _vm.folder_id,
      "default-expanded-keys": [_vm.from_folder_id]
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "autofocus": "",
      "disabled": _vm.folder_name_input_disabled
    },
    model: {
      value: (_vm.form_all_edit.title),
      callback: function($$v) {
        _vm.$set(_vm.form_all_edit, "title", $$v)
      },
      expression: "form_all_edit.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简介",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form_all_edit.intro),
      callback: function($$v) {
        _vm.$set(_vm.form_all_edit, "intro", $$v)
      },
      expression: "form_all_edit.intro"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form_all_edit_batch_visible),
      expression: "form_all_edit_batch_visible"
    }],
    staticClass: "body",
    attrs: {
      "model": _vm.form_all_edit
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "移动到文件夹",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.form_all_edit.directory,
      "props": _vm.form_all_edit.defaultProps,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleBtnCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleUpdateFolder(_vm.form_all_edit_visible ? 'default' : 'batch')
      }
    }
  }, [_vm._v(_vm._s(_vm.form_all_edit_visible ? '确 定' : '移动到'))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog dialog-delete",
    attrs: {
      "title": "提示",
      "visible": _vm.dialog_delete_visible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_delete_visible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.folder_file_type == 'folder'),
      expression: "folder_file_type == 'folder'"
    }],
    staticClass: "text"
  }, [_vm._v("确定要 "), _c('span', [_vm._v("删除")]), _vm._v(" 文件夹 "), _c('span', [_vm._v(_vm._s(_vm.folder_file_title))]), _vm._v(" 吗？这是一个文件夹，会删除其下所有数据！")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.folder_file_type == 'anim' ||
        _vm.folder_file_type == 'scene' ||
        _vm.folder_file_type == 'material' ||
        _vm.folder_file_type == 'prop' ||
        _vm.folder_file_type == 'action' ||
        _vm.folder_file_type == 'bgm' ||
        _vm.folder_file_type == 'template' ||
        _vm.folder_file_type == 'component'),
      expression: "folder_file_type == 'anim' ||\n                                folder_file_type == 'scene' ||\n                                folder_file_type == 'material' ||\n                                folder_file_type == 'prop' ||\n                                folder_file_type == 'action' ||\n                                folder_file_type == 'bgm' ||\n                                folder_file_type == 'template' ||\n                                folder_file_type == 'component' "
    }],
    staticClass: "text"
  }, [_vm._v("确定要 "), _c('span', [_vm._v("删除")]), _vm._v(" 文件 "), _c('span', [_vm._v(_vm._s(_vm.folder_file_title))]), _vm._v(" 吗？")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.folder_file_type == 'other'),
      expression: "folder_file_type == 'other'"
    }],
    staticClass: "text"
  }, [_vm._v("确定要 "), _c('span', [_vm._v("删除")]), _vm._v(" 选中的 "), _c('span', [_vm._v(_vm._s(_vm.folder_file_data.length) + "条")]), _vm._v(" 数据吗？")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleBtnCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleFolderDelete
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialog_bgm_listen_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_bgm_listen_visible = $event
      }
    },
    model: {
      value: (_vm.dialog_bgm_listen_visible),
      callback: function($$v) {
        _vm.dialog_bgm_listen_visible = $$v
      },
      expression: "dialog_bgm_listen_visible"
    }
  }, [_c('div', {
    staticClass: "bgm_info"
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./music.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bgm_title"
  }, [_vm._v(_vm._s(_vm.bgm_title))]), _vm._v(" "), _c('div', {
    staticClass: "bgm_copyright"
  }, [_vm._v(_vm._s(_vm.bgm_copyright))])]), _vm._v(" "), _c('div', {
    staticClass: "bgm_play"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.play_status),
      expression: "play_status"
    }],
    staticClass: "icon-play",
    on: {
      "click": _vm.handleBgmPlay
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.play_status),
      expression: "!play_status"
    }],
    staticClass: "icon-pause",
    on: {
      "click": _vm.handleBgmPause
    }
  }), _vm._v(" "), _c('el-slider', {
    attrs: {
      "max": _vm.max_time,
      "show-tooltip": false
    },
    on: {
      "change": _vm.changeBgmTime
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.current) + " / " + _vm._s(_vm.total_time))])], 1), _vm._v(" "), _c('video', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.audio_src,
      "id": "homepage_audio"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.playerScriptTitle,
      "width": "65%",
      "center": "",
      "top": "80px",
      "visible": _vm.dialog_video_play_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_video_play_visible = $event
      }
    },
    model: {
      value: (_vm.dialog_video_play_visible),
      callback: function($$v) {
        _vm.dialog_video_play_visible = $$v
      },
      expression: "dialog_video_play_visible"
    }
  }, [_c('div', {
    staticClass: "player",
    attrs: {
      "id": "player"
    }
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "playerContainer"
  }, [(_vm.dialog_video_play_visible) ? _c('eu-player', {
    attrs: {
      "source": _vm.playerScriptId,
      "container-id": "homepage-player-canvas"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog dialog-delete",
    attrs: {
      "title": "提示",
      "visible": _vm.dialog_edit_anim,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_edit_anim = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dialog_edit_anim_msg))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog_edit_anim = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.checkEditingAnim()
      }
    }
  }, [_vm._v("查 看")])], 1)]), _vm._v(" "), _c('SDUi', {
    attrs: {
      "visible": _vm.sduiVisible,
      "type": _vm.sduiType,
      "teamId": _vm.sduiTeamId,
      "folderId": _vm.sduiFolderId,
      "workflowId": _vm.sduiWorkflowId
    },
    on: {
      "update:visible": function($event) {
        _vm.sduiVisible = $event
      }
    }
  }), _vm._v(" "), _c('MediaUpload', {
    attrs: {
      "visible": _vm.mediaUploadVisible,
      "type": _vm.sduiType,
      "teamId": _vm.sduiTeamId,
      "folderId": _vm.sduiFolderId
    },
    on: {
      "update:visible": function($event) {
        _vm.mediaUploadVisible = $event
      },
      "refresh": _vm.refreshResourceList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#2a2a2a",
      "position": "absolute",
      "left": "0",
      "top": "0",
      "width": "180px",
      "height": "60px"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("./qqIcon.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./no_result.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./folder.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("./no_result.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83ac0346","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage/HomePage.vue
// module id = 395
// module chunks = 0